import Email from '../../src/legacy/Email.tsx';
export default Email;
